module.exports = __webpack_public_path__ + "img/ipad-mobile_en.9daa79e.jpg";